module.exports = __webpack_public_path__ + "img/img_title_fuwudian_active.d774bf94.png";